/* @flow */

import React from 'react';
import { Segment, Header } from 'semantic-ui-react';
import ResourceCard from 'shared/components/ResourceCard';

type Props = {
  content: CatalogPageContent,
  onSerialize?: (content: CatalogPageContent) => void,
};

const Edit = ({ content, onSerialize }: Props) => {
  const resourceSelected = resource =>
    onSerialize({
      ...content,
      resourceId: resource.id,
      resource,
    });

  const resourceDeleted = () =>
    onSerialize({
      ...content,
      resourceId: undefined,
      resource: undefined,
    });

  return (
    <Segment>
      <Header textAlign="center" content="PDF" />
      <ResourceCard
        resourceType="pdf"
        resource={content.resource}
        onSelected={resourceSelected}
        onDeleted={resourceDeleted}
      />
    </Segment>
  );
};

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/pdf/Edit.js